/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Physical_ModalitiesInputs */

const en_service_type_physical_modalities = /** @type {(inputs: Service_Type_Physical_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physical modalities`)
};

const pl_service_type_physical_modalities = /** @type {(inputs: Service_Type_Physical_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizykoterapia`)
};

/**
* | output |
* | --- |
* | "Physical modalities" |
*
* @param {Service_Type_Physical_ModalitiesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_physical_modalities = /** @type {((inputs?: Service_Type_Physical_ModalitiesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Physical_ModalitiesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_physical_modalities(inputs)
	return en_service_type_physical_modalities(inputs)
});